export default "__VITE_ASSET__BKHWS0Ti__"